import { useEffect, useImperativeHandle } from 'react';

import { Stack } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextArea } from '~components';
import { useFormContainer } from '~hooks';
import Key from '~interfaces/key';

import Dimens from '../../../../themes/dimens';

interface EditFormData {
	description: string;
}

interface EditKeyFormProps {
	initialKey: Key;
	onSubmit: (value: Key) => void;
	onCancel: () => void;
}

const EditKeyForm = ({ initialKey, onSubmit, onCancel }: EditKeyFormProps) => {
	const { setDisabled, formRef } = useFormContainer();

	const { getValues, control, formState } = useForm<EditFormData>({
		defaultValues: {
			description: (initialKey.description ?? '').trim(),
		},
		mode: 'onChange',
	});

	const { t } = useTranslation('entities');

	useImperativeHandle(
		formRef,
		() => ({
			onSubmit: () => onSubmit?.({ ...initialKey, description: getValues().description }),
			onCancel: () => onCancel?.(),
		}),
		[onSubmit, onCancel, getValues, initialKey]
	);

	useEffect(() => {
		setDisabled?.(!formState.isValid);
	}, [formState.isValid, setDisabled]);

	return (
		<Stack spacing={Dimens.spacingMd}>
			<Controller
				name='description'
				control={control}
				render={({ field }) => (
					<TextArea
						{...field}
						label={t('key.fields.description')}
						value={field.value}
						placeholder={t('key.fields.enterDescriptionPlaceholder')}
					/>
				)}
			/>
		</Stack>
	);
};

export default EditKeyForm;
